<template>
	<div class="leftres">
		<!-- <div> -->
		<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
			<div v-for="(item , index) of formdata" :key="index" style="  display: inline-block;">
				<Commondropdownlist ref="challengRef" :key="index" :options="item.options" :minrigth="item.minrigth"
					:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
					:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
					:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types"
					:inputtype="item.inputtype" :width="item.width">
				</Commondropdownlist>
			</div>
			<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
				<CommonBtngroup ref="btngroup" :qhide="false" :show="showorhide" @showclick="showclick" @hide="hide"
					@select="select" @reset="reset">
				</CommonBtngroup>
			</div>
			<div style="height:10px;">
			</div>
		</div>
		<div class="TableBox"
			style=" margin-top: 10px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;display: initial;">
			<Challengingordermanagementcenter :tableDataMD="tableDataMD" @onRowClick="onRowClick" @TVExport="TVExport"
				:tableData="tableData" :total="total" @handleCurrentChange="handleCurrentChange"
				@handleSizeChange="handleSizeChange"></Challengingordermanagementcenter>
		</div>
		<div class="TableBox"
			style=" margin-top: 10px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;display: initial;">
			<Challengingordermanagementbottom :tableDataDetail="tableDataDetail" :tableDataUnique="tableDataUnique"
				:tvmid="tvmid"></Challengingordermanagementbottom>
		</div>
		<!-- </div> -->
	</div>
</template>

<script>
	import Challengingordermanagementcenter from './components/challengingordermanagementcenter.vue'
	import Challengingordermanagementbottom from './components/challengingordermanagementbottom.vue'
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import utils from '../../../common/utils'
	import {
		TransVouchList,
		TransVouchExport,
		Status,
		TransVouchDetail,
		TransVouchDetailUnique,
		InventoryClassList
	} from '@/api/home'
	export default {
		components: {
			Challengingordermanagementcenter,
			Challengingordermanagementbottom,
			Commondropdownlist,
			CommonBtngroup
		},
		data: function() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				tableDataMD: [],
				tableDataDetail: [],
				tableDataUnique: [],
				showorhide: true,
				tvmid: '',
				formdata: [{
						inputdata: '',
						title: '调拨单号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '150px'
					},
					{
						inputdata: '',
						title: '出库客户',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '150px'
					},
					{
						inputdata: "",
						title: "创建时间",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '150px'
					},
					{
						inputdata: '',
						title: '入库客户',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '150px'
					},
					{
						inputdata: '',
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '150px',
						options: [

						]
					},
					{
						inputdata: "",
						title: "确认日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '150px'
					},
					{
						inputdata: '',
						title: '产品型号/名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '150px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '150px',
						options: [

						]
					}
				],
				from: {
					tvCode: "",
					oCusName: "",
					iCusName: "",
					createTime1: "",
					createTime2: "",
					verifyTime1: "",
					verifyTime2: "",
					status: ""
				}
			}
		},
		mounted() {
			this.onchage = 0
			this.inventoryClassList();
			this.transVouchList()
			this.status()
		},
		methods: {
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.formdata[7].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[7].options.push(obj);
					})
				}
			},
			// 列表
			async transVouchList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await TransVouchList({
					tvCode: this.from.tvCode,
					oCusName: this.from.oCusName,
					iCusName: this.from.iCusName,
					createTime1: this.from.createTime1,
					createTime2: this.from.createTime2,
					verifyTime1: this.from.verifyTime1,
					verifyTime2: this.from.verifyTime2,
					status: this.from.status,
					Inventory: this.from.Inventory,
					InvClass: this.from.InvClass,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				//console.log(code, data.data)
				if (code == 0) {
					loading.close();
					this.total = data.Count
					if (data.data) {
						loading.close();
						this.tableData = data.data
					}
				} else {
					loading.close();
				}
			},
			// 导出
			async transVouchExport() {
				let resexprot = await TransVouchExport({
					tvCode: this.from.tvCode,
					oCusName: this.from.oCusName,
					iCusName: this.from.iCusName,
					createTime1: this.from.createTime1,
					createTime2: this.from.createTime2,
					verifyTime1: this.from.verifyTime1,
					verifyTime2: this.from.verifyTime2,
					status: this.from.status,
					Inventory: this.from.Inventory,
					InvClass: this.from.InvClass,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					utils.downloadFile(resexprot.data, "调拨管理导出", "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			TVExport() {
				this.transVouchExport()

			},
			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			// 明细
			async TransVouchDetail() {
				let {
					data,
					code
				} = await TransVouchDetail({
					tvmid: this.tvmid
				})
				if (code == 0) {
					this.tableDataDetail = data
					this.tableDataMD = data
				}
			},
			// 唯一码
			async TransVouchDetailUnique() {
				let {
					data,
					code,
					message
				} = await TransVouchDetailUnique({
					tvmid: this.tvmid
				})
				if (code == 0) {
					this.tableDataUnique = data
					this.tableDataMD = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			onRowClick(val) {
				if (val.TVMID) {
					this.tvmid = val.TVMID
					this.TransVouchDetail()
					this.TransVouchDetailUnique()
				}
			},
			// 状态下拉
			async status() {
				let {
					code,
					data
				} = await Status({})
				if (code == 0) {
					this.formdata[4].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[4].options.push(obj)
					})

				}

			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.transVouchList()
				//console.log(pageindex, 'pageindex')

			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.transVouchList()
			},
			showclick() {
				this.showorhide = true
			},
			select() {
				this.pageindex = 1
				try {
					this.from.tvCode = this.$refs.challengRef[0].modelvalue
					this.from.oCusName = this.$refs.challengRef[1].modelvalue
					this.from.iCusName = this.$refs.challengRef[3].modelvalue
					this.from.createTime1 = this.$refs.challengRef[2].startTime
					this.from.createTime2 = this.$refs.challengRef[2].endTime
					this.from.verifyTime1 = this.$refs.challengRef[5].startTime
					this.from.verifyTime2 = this.$refs.challengRef[5].endTime
					this.from.status = this.$refs.challengRef[4].modelvalue
					this.from.Inventory = this.$refs.challengRef[6].modelvalue
					this.from.InvClass = this.$refs.challengRef[7].modelvalue
					this.transVouchList()
				} catch (error) {
					this.transVouchList()
				}
			},
			reset() {
				this.$refs.challengRef.map((item, index) => {
					if (index == 2 || index == 5) {
						item.startTime = ""
						item.endTime = ""
					}
					item.modelvalue = ""
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.avcite {
		border-left: 4px solid #e71d43;
		background-color: #fce8ec;
		color: #e71d43;
	}

	.leftres {
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.inputtop {
		width: 980px;
		height: 100px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all .3s;
		overflow: hidden;
	}

	.inputtops {
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all .3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 0px;
		width: 300px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 45px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>